import React from "react";
// import FAQData from "../function-components/FAQ/FAQData";
import FAQContent from "../function-components/FAQContent";
function FAQ() {
 return (
  <>
   <FAQContent />
  </>
 );
}

export default FAQ;
